// // src/utils/usePageContent.js
// import { useEffect, useState } from 'react';

// const usePageContent = (pageKey) => {
//   const [content, setContent] = useState({ title: '', description: '' });

//   useEffect(() => {
//     fetch('/siteContent.json')
//     .then(res => res.json())
//     .then(data => {
//         if (data[pageKey]) {
//           setContent(data[pageKey]);
//         } else {
//           console.warn(`Content not found for key: ${pageKey}`);
//         }
//       })
//       .catch(err => {
//         console.error('Failed to load page content:', err);
//       });
//   }, [pageKey]);

//   return content;
// };

// export default usePageContent;


// src/utils/usePageContent.js
import { useSiteContentContext } from './SiteContentProvider';

const usePageContent = (pageKey) => {
  const content = useSiteContentContext();
  return content[pageKey] || { title: '', description: '' };
};

export default usePageContent;
